function getLocale() {
  try {
    const stored = localStorage.getItem('lang');
    if (stored) return stored;
  } catch (_) {}
  if (typeof window !== 'undefined' && window.lang) return window.lang;
  return 'pt-BR';
}

exports.dateToName = (date) => {
  const d = new Date(date);
  const locale = getLocale();
  try {
    return new Intl.DateTimeFormat(locale, { weekday: 'long' }).format(d);
  } catch (_) {
    return new Intl.DateTimeFormat('pt-BR', { weekday: 'long' }).format(d);
  }
};

exports.dateToReadable = (date) => {
  let d = new Date(date);
  return `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`;
};
